import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";

const BidPlacedBox = ({ userType = "Buyer", open, onCancel, onOk }) => {
  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={400} className>
        <div className="drop-shadow-custom">
          <div className="relative">
            <div className="flex justify-center items-center absolute top-0 left-0 w-full h-full">
              <img src="/images/greentick.svg" alt="" />
            </div>
            <div className="w-full h-1/3">
              <img
                src="/images/green.svg"
                alt=""
                className="w-full mt-[-1.3rem]"
              />
            </div>
          </div>

          <h1 className="text-center text-black mt-2 mb-2 text-[17px] font-medium">
            Bid Placed Successfully!!!
          </h1>

          <div className="mx-8 mt-2 mb-6 text-black font-normal text-[12px] text-center">
            <h1>
              You can check the status of this bid in
              <span className="font-bold"> My Bids </span>window.
            </h1>
          </div>

          <div className="flex mx-[2.875rem] gap-5 mt-7 pb-4">
            <Button
              varient="primary"
              borderColor="blue"
              className="  w-[9.375rem] h-[2.5rem] py-2 text-[14px] text-white font-bold  bg-blue-800   "
              onClick={onOk}
            >
              Go to My Bids
            </Button>
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[9.375rem] h-[2.5rem] py-2 text-[14px] border-[1px] border-blue-800 font-bold text-blue-800 bg-blue-100   "
              onClick={onCancel}
            >
              Go Back
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default BidPlacedBox;
